import script from "./ThematicLayers.vue?vue&type=script&setup=true&lang=js"
export * from "./ThematicLayers.vue?vue&type=script&setup=true&lang=js"

import "./ThematicLayers.vue?vue&type=style&index=0&id=66545b1d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66545b1d"]])

export default __exports__